(function () {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  function formatAmount(cents, precision, thousands, decimal) {
    const number = (Number(cents) / 100).toFixed(precision);
    const parts = number.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
    return precision ? dollars + decimal + parts[1] : dollars;
  }

  function formatMoney(cents) {
    const format = String((window.theme && window.theme.moneyFormat) || '${{amount}}').replace(/<[^>]*>/g, '');
    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    const token = match ? match[1] : 'amount';
    let value = formatAmount(cents, 2, ',', '.');
    if (token === 'amount_no_decimals') value = formatAmount(cents, 0, ',', '.');
    if (token === 'amount_with_comma_separator') value = formatAmount(cents, 2, '.', ',');
    if (token === 'amount_no_decimals_with_comma_separator') value = formatAmount(cents, 0, '.', ',');
    if (token === 'amount_with_space_separator') value = formatAmount(cents, 2, ' ', '.');
    if (token === 'amount_no_decimals_with_space_separator') value = formatAmount(cents, 0, ' ', '.');
    if (token === 'amount_with_apostrophe_separator') value = formatAmount(cents, 2, "'", '.');
    return match ? format.replace(match[0], value) : value;
  }

  function escapeHtml(value) {
    return String(value ?? '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
    }[char]));
  }

  function setOpen(element, open, className) {
    if (!element) return;
    element.hidden = !open;
    document.body.classList.toggle(className, open);
  }

  function initHeader() {
    const header = $('.header');
    if (!header || header.dataset.ready === 'true') return;
    header.dataset.ready = 'true';
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initMobileNav() {
    const nav = $('[data-mobile-nav]');
    if (!nav) return;
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-menu-open]')) {
        nav.hidden = false;
        document.body.classList.add('overflow-hidden');
        $('[data-menu-close]', nav)?.focus();
      }
      if (event.target.closest('[data-menu-close]')) {
        nav.hidden = true;
        document.body.classList.remove('overflow-hidden');
      }
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !nav.hidden) {
        nav.hidden = true;
        document.body.classList.remove('overflow-hidden');
      }
    });
  }

  function initAnnouncement() {
    $$('[data-announcement][data-dismissible="true"]').forEach((bar) => {
      const key = `vocks-announce:${bar.dataset.message || ''}`;
      try {
        if (sessionStorage.getItem(key) === '1') bar.remove();
      } catch (error) {
        /* storage unavailable */
      }
    });
  }

  document.addEventListener('click', (event) => {
    const dismiss = event.target.closest('[data-announcement-dismiss]');
    if (!dismiss) return;
    const bar = dismiss.closest('[data-announcement]');
    if (!bar) return;
    try {
      sessionStorage.setItem(`vocks-announce:${bar.dataset.message || ''}`, '1');
    } catch (error) {
      /* storage unavailable */
    }
    bar.remove();
  });

  function initSliders() {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    $$('[data-slider]').forEach((slider) => {
      if (slider.dataset.ready === 'true') return;
      slider.dataset.ready = 'true';
      const slides = () => $$('[data-slide]', slider);
      const dots = () => $$('[data-slide-to]', slider);
      let index = 0;
      let timer;

      function show(next) {
        const items = slides();
        if (!items.length) return;
        index = (next + items.length) % items.length;
        items.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === index));
        dots().forEach((dot, dotIndex) => {
          if (dotIndex === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      function stop() {
        if (timer) window.clearInterval(timer);
      }

      function start() {
        stop();
        if (slider.dataset.autoplay === 'true' && !reduce && slides().length > 1) {
          timer = window.setInterval(() => show(index + 1), 6500);
        }
      }

      slider.addEventListener('click', (event) => {
        if (event.target.closest('[data-slider-next]')) show(index + 1);
        if (event.target.closest('[data-slider-prev]')) show(index - 1);
        const dot = event.target.closest('[data-slide-to]');
        if (dot) show(Number(dot.dataset.slideTo));
        if (event.target.closest('[data-slider-next], [data-slider-prev], [data-slide-to]')) start();
      });

      slider.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') show(index + 1);
        if (event.key === 'ArrowLeft') show(index - 1);
      });

      document.addEventListener('shopify:block:select', (event) => {
        const slide = event.target.closest('[data-slide]');
        if (!slide || !slider.contains(slide)) return;
        show(slides().indexOf(slide));
        stop();
      });

      start();
    });
  }

  function cartDrawer() {
    return $('[data-cart-drawer]');
  }

  function updateCount(count) {
    $$('[data-cart-count]').forEach((node) => {
      node.textContent = String(count);
      node.hidden = count < 1;
    });
  }

  function lineMarkup(item) {
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<p class="cart-line__variant">${escapeHtml(item.variant_title)}</p>`
      : '';
    const plan = item.selling_plan_allocation
      ? `<p class="cart-line__variant">${escapeHtml(item.selling_plan_allocation.selling_plan.name)}</p>`
      : '';
    const image = item.image
      ? `<a class="cart-line__media" href="${item.url}"><img src="${item.image}" alt=""></a>`
      : '<span class="cart-line__media"></span>';
    return `<article class="cart-line">${image}<div class="cart-line__info"><a href="${item.url}">${escapeHtml(item.product_title)}</a>${variant}${plan}<div class="qty"><button type="button" data-line-qty="-1" data-line-key="${item.key}" aria-label="Decrease">−</button><span>${item.quantity}</span><button type="button" data-line-qty="1" data-line-key="${item.key}" aria-label="Increase">+</button></div><button type="button" class="text-button" data-line-remove data-line-key="${item.key}">${escapeHtml(window.theme.strings.remove)}</button></div><p class="cart-line__price">${formatMoney(item.final_line_price)}</p></article>`;
  }

  function renderCart(cart) {
    const items = $('[data-cart-items]');
    const subtotal = $('[data-cart-subtotal]');
    updateCount(cart.item_count);
    if (items) {
      items.innerHTML = cart.items.length
        ? cart.items.map(lineMarkup).join('')
        : `<p class="cart-drawer__empty">${escapeHtml(items.dataset.empty || window.theme.strings.cartEmpty)}</p>`;
    }
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
  }

  async function refreshCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    const cart = await response.json();
    renderCart(cart);
    return cart;
  }

  function openCart(opener) {
    const drawer = cartDrawer();
    if (!drawer) {
      window.location.href = window.theme.routes.cart;
      return;
    }
    drawer.hidden = false;
    document.body.classList.add('overflow-hidden');
    drawer.dataset.opener = 'open';
    if (opener) drawer._opener = opener;
    $('[data-cart-close]', drawer)?.focus();
  }

  function closeCart() {
    const drawer = cartDrawer();
    if (!drawer) return;
    drawer.hidden = true;
    document.body.classList.remove('overflow-hidden');
    drawer._opener?.focus();
  }

  async function changeLine(key, quantity) {
    const response = await fetch(window.theme.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!response.ok) return;
    renderCart(await response.json());
  }

  async function addVariant(id, quantity, opener) {
    const response = await fetch(window.theme.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: quantity || 1 }] })
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      window.alert(error.description || error.message || 'Could not add this item.');
      return;
    }
    await refreshCart();
    openCart(opener);
  }

  function initCart() {
    document.addEventListener('click', async (event) => {
      const opener = event.target.closest('[data-cart-open]');
      if (opener && cartDrawer()) {
        event.preventDefault();
        openCart(opener);
      }
      if (event.target.closest('[data-cart-close]')) closeCart();

      const quick = event.target.closest('[data-quick-add]');
      if (quick) {
        quick.disabled = true;
        await addVariant(quick.dataset.quickAdd, 1, quick);
        quick.disabled = false;
      }

      const line = event.target.closest('[data-line-qty], [data-line-remove]');
      if (line) {
        const current = line.closest('.cart-line')?.querySelector('.qty span');
        const quantity = line.hasAttribute('data-line-remove')
          ? 0
          : Math.max(0, Number(current?.textContent || 1) + Number(line.dataset.lineQty));
        await changeLine(line.dataset.lineKey, quantity);
      }

      const pageQty = event.target.closest('[data-cart-page-qty]');
      if (pageQty) {
        const input = pageQty.parentElement.querySelector('input');
        const next = Math.max(0, Number(input.value || 0) + Number(pageQty.dataset.cartPageQty));
        input.value = String(next);
        pageQty.closest('form')?.submit();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeCart();
    });

    document.addEventListener('change', async (event) => {
      const note = event.target.closest('[data-cart-note]');
      if (!note || !window.theme.routes.cartUpdate) return;
      await fetch(window.theme.routes.cartUpdate, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    });
  }

  function selectedOptions(form) {
    return $$('[data-option-input]:checked', form).map((input) => input.value);
  }

  function findVariant(variants, options) {
    return variants.find((variant) => variant.options.every((option, index) => option === options[index]));
  }

  function syncVariant(form) {
    const dataNode = $('[data-product-variants]', form);
    if (!dataNode) return;
    const variants = JSON.parse(dataNode.textContent);
    const options = selectedOptions(form);
    const variant = findVariant(variants, options);
    const idInput = $('input[name="id"]', form);
    const addButton = $('[data-add-to-cart]', form);
    const error = $('[data-product-error]', form);
    const current = $('[data-price-current]', form);
    const compare = $('[data-price-compare]', form);
    const sku = $('[data-sku]', form);
    const inventory = $('[data-inventory]', form);

    $$('[data-option-input]', form).forEach((input) => {
      const index = Number(input.dataset.optionIndex);
      const available = variants.some((item) => {
        if (item.options[index] !== input.value || !item.available) return false;
        return options.every((selected, optionIndex) => optionIndex === index || item.options[optionIndex] === selected);
      });
      input.parentElement.classList.toggle('is-unavailable', !available);
    });

    options.forEach((value, index) => {
      const label = form.querySelector(`[data-selected-option="${index}"]`);
      if (label) label.textContent = value;
    });

    if (!variant) {
      if (addButton) {
        addButton.disabled = true;
        addButton.textContent = window.theme.strings.unavailable;
      }
      return;
    }

    if (idInput) idInput.value = variant.id;
    if (current) {
      current.textContent = formatMoney(variant.price);
      current.classList.toggle('price__current--sale', variant.compare_at_price > variant.price);
    }
    if (compare) {
      compare.hidden = !(variant.compare_at_price > variant.price);
      compare.textContent = formatMoney(variant.compare_at_price || 0);
    }
    if (sku) sku.textContent = variant.sku ? `SKU ${variant.sku}` : '';
    if (inventory) {
      const low = variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 10;
      inventory.textContent = low ? `Only ${variant.inventory_quantity} left` : '';
    }
    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available ? window.theme.strings.addToCart : window.theme.strings.soldOut;
    }
    if (error) error.textContent = '';

    const mediaId = variant.featured_media && variant.featured_media.id;
    const gallery = form.closest('.product')?.querySelector('[data-gallery]') || $('[data-gallery]');
    if (mediaId && gallery) activateMedia(gallery, mediaId);

    const stickyPrice = $('[data-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);
  }

  function activateMedia(gallery, mediaId) {
    $$('[data-media-id]', gallery).forEach((slide) => {
      slide.classList.toggle('is-active', slide.dataset.mediaId === String(mediaId));
    });
    $$('[data-thumb]', gallery).forEach((thumb) => {
      thumb.classList.toggle('is-active', thumb.dataset.thumb === String(mediaId));
    });
  }

  function initProducts() {
    document.addEventListener('change', (event) => {
      if (event.target.closest('[data-option-input]')) {
        syncVariant(event.target.closest('[data-product-form]'));
      }
    });

    document.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-thumb]');
      if (thumb) activateMedia(thumb.closest('[data-gallery]'), thumb.dataset.thumb);

      const qty = event.target.closest('[data-qty]');
      if (qty && !qty.hasAttribute('data-line-qty') && !qty.hasAttribute('data-cart-page-qty')) {
        const input = qty.parentElement.querySelector('input');
        if (!input) return;
        const min = Number(input.min || 1);
        input.value = String(Math.max(min, Number(input.value || 1) + Number(qty.dataset.qty)));
      }

      const sticky = event.target.closest('[data-sticky-submit]');
      if (sticky) {
        const form = $('[data-product-form]');
        const add = form && $('[data-add-to-cart]', form);
        if (form && add) form.requestSubmit(add);
      }
    });

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-product-form]');
      if (!form || !cartDrawer()) return;
      const submitter = event.submitter;
      if (!submitter || !submitter.hasAttribute('data-add-to-cart')) return;
      event.preventDefault();
      const error = $('[data-product-error]', form);
      submitter.classList.add('is-loading');
      submitter.disabled = true;
      try {
        const body = new FormData(form);
        if (!body.get('selling_plan')) body.delete('selling_plan');
        const response = await fetch(window.theme.routes.cartAdd, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body
        });
        const data = await response.json();
        if (!response.ok) {
          if (error) error.textContent = data.description || data.message || window.theme.strings.unavailable;
          return;
        }
        await refreshCart();
        openCart(submitter);
      } catch (fetchError) {
        if (error) error.textContent = window.theme.strings.unavailable;
      } finally {
        submitter.classList.remove('is-loading');
        submitter.disabled = false;
        syncVariant(form);
      }
    });

    const sticky = $('[data-sticky-atc]');
    const anchor = $('[data-add-to-cart]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(([entry]) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', passed);
      });
      observer.observe(anchor);
    }
  }

  function initRecommendations() {
    $$('[data-recommendations].section--pending').forEach(async (section) => {
      if (!section.dataset.url || section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';
      try {
        const response = await fetch(section.dataset.url);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const next = doc.querySelector('[data-recommendations]');
        if (!next || !next.querySelector('.card')) return;
        section.innerHTML = next.innerHTML;
        section.classList.remove('section--pending');
      } catch (error) {
        /* recommendations are optional */
      }
    });
  }

  function initFilters() {
    document.addEventListener('change', (event) => {
      if (event.target.closest('[data-auto-submit]')) {
        event.target.form?.submit();
      }
    });
  }

  function initAccount() {
    const showRecover = $('[data-show-recover]');
    const hideRecover = $('[data-hide-recover]');
    const main = $('[data-login-main]');
    const recover = $('[data-login-recover]');
    showRecover?.addEventListener('click', () => {
      main?.classList.add('is-hidden');
      recover?.classList.add('is-open');
    });
    hideRecover?.addEventListener('click', () => {
      main?.classList.remove('is-hidden');
      recover?.classList.remove('is-open');
    });
    if (window.location.hash === '#recover') showRecover?.click();

    $$('[data-country-select]').forEach((country) => {
      const province = document.getElementById(country.dataset.province);
      const container = document.getElementById(country.dataset.container);
      if (window.Shopify && Shopify.CountryProvinceSelector && province) {
        new Shopify.CountryProvinceSelector(country.id, province.id, { hideElement: container && container.id });
      }
    });
  }

  function boot() {
    initHeader();
    initAnnouncement();
    initSliders();
    initRecommendations();
  }

  function start() {
    initMobileNav();
    initCart();
    initProducts();
    initFilters();
    initAccount();
    boot();
    document.addEventListener('shopify:section:load', boot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
